import {Component, OnInit, OnDestroy,Inject} from '@angular/core';


import {AuthService} from "../services/auth/AuthService";
import {LoginVM} from "../models/LoginVM";

import { ActivatedRoute, Router } from '@angular/router';
import {AlertService} from "../services/alert/alert.service";

import {CacheUtilService} from "../services/cache-util/CacheUtilService";
import {TranslateService} from "../../../node_modules/ng2-translate/src/translate.service";
import {MatDialogModule} from '@angular/material';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {UserVM} from "../models/UserVM";


const USERNAME_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

/**
 * A Sample of how simple it is to create a new window, with its own injects.
 */
@Component({
  selector: 'fr-login',
  template: require('./login.component.html'),
  styles: [require('./login.style.css')],

  providers: [AuthService]
})
export class LoginComponent  {


  public wrongAnswer:boolean;
  public userName;
  public password;
  public captchaKey;
  public userNameValidationMessage = '';
  public error = null;
  public selectedIndex:number=0;
  public isLoginLinkVisable=true;
  public noPasswordLoginEnabled=false;

  constructor(private authService:AuthService,
              @Inject(MAT_DIALOG_DATA) public data:any,
              public route:ActivatedRoute,
              public router:Router,
              public dialog:MatDialog,
              private alertService:AlertService,
              private cacheUtil:CacheUtilService,
              private translate:TranslateService

  ) {

    if(data)
      this.noPasswordLoginEnabled = data.noPasswordLoginEnabled;

  }

  openRegisterForm() {
    this.route.queryParams.subscribe((p)=> {
      let backurl = p['backurl'];
      this.router.navigateByUrl('/register?backurl=' + backurl);
    })

  }



  openResetPasswordForm() {
    this.route.queryParams.subscribe((p)=> {

      this.dialog.closeAll();
      //this.router.navigateByUrl('/reset-password');
    })

  }

  login() {

    if (this.isFormValid()) {
      let credential:LoginVM = new LoginVM();
      credential.userName = this.userName;
      credential.password = this.password;
      credential.rememberMe = true;
      credential.captchaCode = this.captchaKey;
      let parent = this;
      this.error = null;
      this.authService.login(credential) .then(function (data) {
          parent.cacheUtil.storeInCache("jhi-authenticationToken", data);


          parent.authService.loggedIn().then(async (res)=> {
            await  parent.authService.updateLoginStatus();
            await  parent.doAfterSuccessLogin();
            const event = new Event("loggedIn");
            window.dispatchEvent(event);
          });

        })
        .catch(function (err) {
          parent.alertService.showErrorMessage('global.messages.error.failedLogin');
        });
      ;
    }
  }
  showLoginTab()
  {

    this.selectedIndex=1;
  }
  showRegisterTab()
  {
    this.selectedIndex=0;
  }
  authenticateSuccess(data, status, headers) {
    var bearerToken = headers('Authorization');
    var jwt = bearerToken.slice(7, bearerToken.length);
    return jwt;

  }

  doAfterSuccessLogin() {

    this.alertService.showSuccessMessage('global.messages.info.SuccessfulLogin');
    this.dialog.closeAll();
    this.route.queryParams.subscribe((p)=> {
      //let backurl = p['backurl'];
      //this.authService.setAsLoggedIn();
      //if(!backurl)backurl='home';
      //this.router.navigateByUrl(backurl);
    })

  }

  isFormValid() {
    this.clearErrorMessages();
    return (
      this.isUserNameValid() &&
      this.isPasswordValid()
    )
  }

  clearErrorMessages() {
    this.userNameValidationMessage = "";
  }

  isUserNameValid():boolean {
    let isValid:boolean = true;
    ;
    if (!this.userName) {
      this.userNameValidationMessage = this.translate.instant('vmsg.userNameIsRequired');
      isValid = false;
    }
    return isValid;

  }

  isPasswordValid():boolean {
    let isValid:boolean = true;
    ;
    if (!this.password) {

      isValid = false;
    }
    return isValid;

  }

  doAfterRegister(regUser:UserVM) {
    this.userName = regUser.login;
    this.password = regUser.password;
    this.login();

  }

  beforeDismiss():boolean {
    return true;
  }

  beforeClose():boolean {
    return true;
  }

  handleCorrectCaptcha(e) {
    this.captchaKey = e;
  }
  onStepChanged(e)
  {

    this.isLoginLinkVisable=true;

    if(e>1)
    this.isLoginLinkVisable=false;

  }


  onUserChanged(user)
  {

    if(user)
      this.doAfterSuccessLogin()
    //alert('user changed');
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/login/login.component.ts